module.exports = __webpack_public_path__ + "img/57.13bf5e9b.jpg";